// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3v8em","containerItemsCenter":"Skeleton_containerItemsCenter__2faxg"};